import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigProvider {
  constructor(public http: HttpClient) {
    // console.log('Hello AppConfigProvider Provider');
  }

  apiUrl(): string {
    return 'http://salihin.noip.me/syariah-admin/';
    // return 'http://localhost/syariah-admin/';
  }

  appKey(): string {
    return '5a38d3a6-c059-4fd9-950f-dd10e4bad6ad';
  }

  billPlzKey(): string {
    return 'bf7c6276-b923-4979-84e3-6e03dcfe3fa9';
  }
}



// WEBPACK FOOTER //
// ./src/providers/app-config/app-config.ts